<template>
  <div class="forget">
    <topnav title="找回密码"/>
    <div class="main">
      <div class="my-form">
        <div class="title">找回密码</div>
        <div class="content">
          <div class="input-group">
            <label for="username"><span>*</span>登录账号</label>
            <input type="text" id="username" name="username" placeholder="请输入登录账号" v-model="formData.username">
          </div>
          <div class="input-group">
            <label for="mobile"><span>*</span>手机号码</label>
            <div class="code">
              <input type="text" id="mobile" name="mobile" placeholder="请输入手机号" v-model="formData.mobile">
              <van-button v-if="!isSendSmsCode" type="primary" size="small" @click="getSmsCode">验证码</van-button>
              <div v-else class="code-tips">倒计时<span>{{smsCodeNumber}}</span>s</div>
            </div>
          </div>
          <div class="input-group">
            <label for="code"><span>*</span>验证码</label>
            <input type="text" id="code" name="code" placeholder="请输入验证码" maxlength="4" v-model="formData.code">
          </div>
          <div class="input-group">
            <label for="password"><span>*</span>登录密码</label>
            <input type="password" id="password" name="password" placeholder="请输入登录密码" v-model="formData.password">
          </div>
          <div class="input-group">
            <label for="rePassword"><span>*</span>确认密码</label>
            <input type="password" id="rePassword" name="rePassword" placeholder="请再次输入登录密码" v-model="formData.rePassword">
          </div>
          <div class="input-group btn">
            <van-button type="primary" color="#3ad2d9" class="login" @click="register">立即提交</van-button>
            <van-button type="primary" color="#ffffff" class="register" @click="goLogin">前往登录</van-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Topnav from '@/components/Topnav'
import { sendMsg } from '@/api/common.js'
import { forget } from '@/api/user.js'
import { Notify, Toast } from 'vant';

export default {
  name: 'Forget',
  components: {
    Topnav
  },
  data() {
    return {
      formData: {
        username: '',
        mobile: '',
        code: '',
        password: '',
        rePassword: '',
      },
      formErrorTips: ['登录账号不能为空', '手机号码不能为空', '验证码不能为空', '登录密码不能为空', '确认密码不能为空'],
      isSendSmsCode: false,
      smsCodeNumber: 120
    }
  },
  methods: {
    register() {
      let tempFormData = {};
      let arr = Object.keys(this.formData);
      for(let i=0; i<arr.length; i++) {
        if(this.formData[arr[i]] == '') {
          Toast({
            message: this.formErrorTips[i],
            position: 'bottom',
          }); 
          return false;
        }
        if(arr[i] == 'rePassword') {
          if(this.formData[arr[i]] != this.formData.password) {
            Toast({
            message: '两次密码输入不一致',
            position: 'bottom',
          }); 
            return false;
          }
        }else {
          tempFormData[arr[i]] = this.formData[arr[i]];
        }
      }
      forget(tempFormData).then(res => {
        Notify({ 
          type: 'success', 
          message: '密码找回成功，跳转到登录页面',
          onClose: () => {
            this.$router.push({
              name: 'Login'
            })
          }
        });
      }).catch(err => {
        console.error(err);
      })
    },
    goLogin() {
      this.$router.push({
        name: 'Login'
      })
    },
    getSmsCode() {
      let tempFormData = {
        mobile: ''
      }
      if(this.formData.mobile == '') {
        Toast({
          message: '手机号码不能为空',
          position: 'bottom',
        });
        return false;
      }else if(!(/^1(3|4|5|6|7|8|9)\d{9}$/.test(this.formData.mobile))){
        Toast({
          message: '手机号码格式不正确',
          position: 'bottom',
        });
        return false;
      }
      tempFormData.mobile = this.formData.mobile;
      this.isSendSmsCode = true;
      let codeTimer = setInterval(() => {
        if(this.smsCodeNumber <= 0) {
          clearInterval(codeTimer);
          this.isSendSmsCode = false;
          this.smsCodeNumber = 120;
          return false;
        }
        this.smsCodeNumber--;
      },1000)
      sendMsg(tempFormData).then(res => {
        Toast({
          message: '短信验证码发送成功，请查收',
          position: 'bottom',
        });
      }).catch(err => {
        console.error(err);
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.main{
  padding-top: var(--window-top);
  .my-form{
    width: 7rem;
    margin: 1rem auto 0;
    border: 1px solid #dcdcdc;
    .title{
      height: 0.8rem;
      line-height: 0.8rem;
      font-size: 0.38rem;
      color: #2eaeb4;
      padding: 0 0.12rem;
      background-color: #dcdcdc;
    }
    .content{
      padding: 0.6rem 0.12rem;
      .input-group{
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 0.2rem;
        label{
          font-size: 0.32rem;
          color: #666666;
          span{
            color: #ff0000;
          }
        }
        button{
          width: 1.6rem;
        }
        input{
          width: 4.8rem;
          height: 0.8rem;
          line-height: 0.8rem;
          font-size: 0.32rem;
          border: 1px solid #dcdcdc;
          padding: 4px 8px;
          &::placeholder{
            color: #a4a4a4;
          }
        }
        &.btn button{
          width: 2rem;
          height: 0.8rem;
          line-height: 0.8rem;
          &.login{
            color: #ffffff;
          }
          &.register{
            color: #2eaeb4!important;
            border-color: #dfdfdf!important;
          }
        }
        .code{
          width: 4.8rem;
          display: flex;
          align-items: center;
          justify-content: space-between;
          input{
            width: 2.8rem;
          }
          .code-tips{
            font-size: 0.32rem;
            color: #666666;
          }
        }
        &.btn{
          justify-content: center;
          margin-top: 0.4rem;
        }
        &.btn button.login{
          margin-right: 0.2rem;
        }
      }
    }
  }
}
</style>